import momentJalaali from "moment-jalali";
import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import DatePicker from 'react-datepicker2';
import "react-datepicker2/src/styles/style.css";
import { setDialog } from '../store/api/GetAllProduct';
import { invoiceTypesArray, setErrorDialog, useIsMobileApp } from "../../store/api/CommonFunctions";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useHistory } from 'react-router-dom';
import { useState, useRef, useEffect, Fragment } from 'react';
import ModalProducts from "../../Components/Modals/ModalProducts";
import ModalSelectStaff from "../../Components/Modals/ModalSelectStaff";
import { Accordion, Button, Card, Col, Form, FormGroup, OverlayTrigger, Popover, Table } from 'react-bootstrap';
import ModalRequestComments from '../Components/Tasks/ModalRequestComments';
import ModalSelectCustomer from "../../Components/Modals/ModalSelectCustomer";
import ModalChangeRequestStatus from '../Components/Tasks/ModalChangeRequestStatus';
import { PlusLg, Save, List, Trash, ExclamationSquare, Command, LayerForward, UiChecksGrid, FileEarmarkSpreadsheet, Printer, FileEarmarkCheck, FileEarmarkPlus } from 'react-bootstrap-icons';
import {
  addNewProductRequest, addNewProductRequestKala, changeStatusToInit, deleteProductRequestKala, getProductRequest, getProductRequestStatusList,
  setPopChangeRequestStatus, setRequestCommentsPopup, addNewBorrow, resetProductRequest,
  addNewPurchaseForRequest,
  addNewPrePurchaseForRequest,
  addNewInvoiceForRequest
} from '../store/api/ProductRequest';
import { invoiceTypes, keyIsLetterOrNumber, productRequestStatuses } from "../../store/api/CommonFunctions";
import { useCallback } from "react";
import { getSystemSettings } from "../../Sale/store/api/Invoice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faListAlt, faReceipt } from "@fortawesome/free-solid-svg-icons";
import { searchStorage4Modal } from "../../BaseInfo/store/api/StorageApi";
import ModalSearchStorage from "../../Components/Modals/ModalSearchStorage";
const PartRequest = () => {
  const dispatch = useDispatch();
  let { ID } = useParams();
  const history = useHistory();
  const isMobile = useIsMobileApp();
  const requestData = useRef({});
  const submitInvoiceData = useRef({});
  const frmRequestDetails = useRef();
  const [requestDate, setRequestDate] = useState(null);
  const { handleSubmit, register, errors } = useForm();
  const [loading, setLoading] = useState(false);
  const [checkRequired, setRequired] = useState(false);
  const [isStaffEmpty, setStaffEmpty] = useState(null);
  const [selectedStaff, setStaffData] = useState(null);
  const [selectedProduct, selectProduct] = useState({});
  let [requestDetails, setRequestDetails] = useState([]);
  const [selectedCustomer, selectCustomer] = useState({});
  const [popStaff, setPopStaff] = useState({ show: false });
  const [popProduct, setPopProduct] = useState({ show: false });
  const [selectedMainProduct, selectMainProduct] = useState({});
  const [modalStorage, setModalStorage] = useState({show:false});
  const [pendingInvoice, setPendingInvoice] = useState(false);
  const roleList = JSON.parse(localStorage.getItem("RoleList"));
  const [popCustomer, setPopCustomer] = useState({ show: false });
  const systemSettings = useSelector(state => state.SystemSettingsReducer.systemSettings);
  const settingNames = ["ProductGrouppingType", "ProductDefaultSalePrice", "ProductDefaultSalePriceLabel"];
  const pDefaultSalePrice = systemSettings && Array.isArray(systemSettings) ? systemSettings.find(s => s.SettingName === "ProductDefaultSalePrice")?.SettingValue : "";
  const pDefaultSalePriceLabel = systemSettings && Array.isArray(systemSettings) ? systemSettings.find(s => s.SettingName === "ProductDefaultSalePriceLabel")?.SettingValue : "";
  const pgType = systemSettings && Array.isArray(systemSettings) && systemSettings.find(s => s.SettingName === "ProductGrouppingType") ?
    Number(systemSettings.find(s => s.SettingName === "ProductGrouppingType").SettingValue) : 1;

  let productRequest = useSelector(state => state.ProductRequestReducer.productRequest);
  useEffect(() => {
    setStaffData(null);
    setStaffEmpty(null);
    selectProduct({});
    selectMainProduct({});
    selectCustomer({});

    document.body.className = "notMain";
    dispatch(getSystemSettings(settingNames));
    if (Number(ID ?? 0) > 0) {
      const onSuccess = (res) => {
        const segmentList = res.SegmentList;
        if (res.RequestDate)
          setRequestDate(res.RequestDate.substring(0, 10));
        if (segmentList && segmentList.length > 0) {
          let details = segmentList.slice();
          for (let i = 0; i < details.length; i++) {
            details[i].Index = i + 1;
          }

          setRequestDetails(details);
        }
      }
      dispatch(getProductRequest(ID, onSuccess));
    }
    else {
      dispatch(resetProductRequest());
    }


  }, [ID]);

  const showMessages = () => {
    dispatch(setRequestCommentsPopup({ status: 'show' }));
  }

  const onSubmit = () => {
    let staffID = document.getElementById("RF_StaffID")?.value;
    if (staffID === '') {
      setStaffEmpty(true);
      return;
    }
    else {
      setStaffEmpty(false);
    }

    if (Number(productRequest.ID) === -1) {
      if (!selectedMainProduct.ProductID || selectedMainProduct.ProductID === '' ||
        !requestData.current.TypeAddress || requestData.current.TypeAddress === '' ||
        !requestData.current.RequestAddress || requestData.current.RequestAddress === '') {
        setRequired(true);
        return;
      }
      else {
        setRequired(false);
      }
      productRequest = {};
      productRequest.ProductID = selectedMainProduct.ProductID;
      //For OnSucess In Submit
      productRequest.ProductName = selectedMainProduct.ProductName;
      productRequest.ProductModel = selectedMainProduct.ProductModel;
      productRequest.StatusCode = productRequestStatuses.Draft;
      productRequest.StatusStr = 'پیش نویس';
      productRequest.CustomerName = selectedCustomer.Name;
      //
      productRequest.ProductSerial = requestData.current.ProductSerial;
      productRequest.CustomerID = selectedCustomer.ID;
      productRequest.TypeAddress = requestData.current.TypeAddress;
      productRequest.RequestAddress = requestData.current.RequestAddress;
      productRequest.RequestDate = requestDate;

    }
    if (staffID) {
      productRequest.StaffID = staffID;
    }
    if (!requestDetails || requestDetails.length === 0) {
      setErrorDialog(dispatch, "ردیفی برای درخواست وارد نشده است", "ثبت درخواست");
      return;
    }
    productRequest.SegmentList = requestDetails;
    const onSuccess = (segmentList, id) => {
      history.push("/Services/PartRequest/" + id);
      ID = id;
      productRequest.ID = id;
      let details = segmentList.slice();
      setRequestDetails(details);
    }
    dispatch(addNewProductRequest(productRequest, onSuccess));

  };

  const AddSegment = (data) => {
    if (!selectedProduct || !selectedProduct.ProductID) {
      setErrorDialog(dispatch, "قطعه ای انتخاب نشده است", "ثبت درخواست قطعه");
      return;
    }
    if (requestDetails.find(d => d.ProductID === selectedProduct.ProductID)) {
      setErrorDialog(dispatch, "این قطعه در لیست وجود دارد", "ثبت درخواست قطعه");
      return;
    }
    if (productRequest.IsNew) {
      requestDetails = [];
      productRequest.IsNew = null;
    }
    let details = requestDetails.slice();
    const item = {
      Index: details.length + 1,
      ProductID: selectedProduct.ProductID,
      ProductModel: selectedProduct.ProductModel,
      ProductName: selectedProduct.ProductName,
      Counts: data.Count ?? 1,
      Description: data.Description,
      IsGaurantee: data.IsGaurantee === true
    }
    selectProduct({});
    if (productRequest && productRequest.ID > 0) {
      const onSuccess = (id) => {
        frmRequestDetails.current.reset();
        item.ID = id;
        details.push(item);
        setRequestDetails(details);
      }
      item.RequestID = productRequest.ID;
      dispatch(addNewProductRequestKala(item, onSuccess));
    }
    else {
      frmRequestDetails.current.reset();
      details.push(item);
      setRequestDetails(details);
    }
  };
  function showModalProduct(e) {
    if (e.key) {
      if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
        return;
      }
      e.preventDefault();
    }
    const setData = (data) => {
      if (data) {
        selectProduct(data);
      }
    }
    setPopProduct({ show: true, value: e.key, setProductData: setData, forPartRequest: true });
    const inputCount = document.getElementById("requestProductCount");
    inputCount.focus();
  }
  function showModalMainProduct(e) {
    if (e.key) {
      if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
        return;
      }
      e.preventDefault();
    }
    const setData = (data) => {
      if (data) {
        selectMainProduct(data);
      }
    }
    setPopProduct({ show: true, value: e.key, setProductData: setData, invoiceType: invoiceTypes.Purchase });
    const inputCount = document.getElementById("requestProductCount");
    inputCount.focus();
  }
  const deleteRow = (index, id) => {
    return () => {
      const deleteLocalRow = () => {
        let details = requestDetails.filter(d => d.Index !== index);
        for (let i = 0; i < details.length; i++) {
          details[i].Index = i + 1;
        }
        setRequestDetails(details);
      }
      if (id && id !== 0) {
        dispatch(deleteProductRequestKala(id, deleteLocalRow));
      }
      else {
        deleteLocalRow();
      }

    }
  }
  const showCommand = () => {
    history.push("/Services/Commands/0/" + productRequest.ID + "/" + "ProductRequest");
  }
  const showModalStatus = () => {
    dispatch(getProductRequestStatusList());
    dispatch(setPopChangeRequestStatus({ show: true, requestID: productRequest.ID }))
  }
  const sendRequest = () => {
    const onSuccess = () => {
      productRequest.StatusStr = 'درخواست شد';
      productRequest.StatusCode = productRequestStatuses.InitRequest;
      setLoading(false);
    }
    setLoading(true);
    dispatch(changeStatusToInit(productRequest.ID, onSuccess))
  }
  const addNewInvoice = (invoiceType) => {
    if (!submitInvoiceData.current.StorageID || pendingInvoice) {
      return;
    }
    const pInvoiceType = invoiceTypesArray.find(i=>i.TypeName === invoiceType)?.TypeStr;
    const onSuccess = (res) => {
      if (res !== "PENDING") {
        setPendingInvoice(false);
        submitInvoiceData.current = {};
      }
      if (res.Error) {
        setErrorDialog(dispatch, res.Error, `ثبت ${pInvoiceType}`, 15000);
      }
      else if (res.Data) {
        setErrorDialog(dispatch, `${pInvoiceType} با شماره ${res.Data.InvoiceNumber} صادر شد.`);
        productRequest.StatusCode = productRequestStatuses.Closed;
        productRequest.StatusStr = "بسته شده";
        history.replace("/Services/PartRequest/" + productRequest.ID);
      }

    }
    const data = { RequestID: productRequest.ID, InvoiceType: invoiceType, StorageID: submitInvoiceData.current.StorageID, CustomerID: submitInvoiceData.current.CustomerID };
    setPendingInvoice(true);
    addNewInvoiceForRequest(data, onSuccess);
  }
  function showModalStaff(e) {
    if (e.key) {
      if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
        return;
      }
      e.preventDefault();
    }
    setPopStaff({ show: true, onSelect: setStaffData, value: e.key });
  }
  function showModalCustomer(e) {
    if (e.key) {
      if (!keyIsLetterOrNumber(e.keyCode, e.key)) {
        return;
      }
      e.preventDefault();
    }
    const onSelectCust = (data) => {
      if (data) {
        selectCustomer(data);
      }
    }
    setPopCustomer({ show: true, value: e.key, invoiceCustomers: true, setCustomerData: onSelectCust });
  }
  function showModalCustomerForInvoice(invoiceType) {

    const onSelectCust = (data) => {
      if (data) {
       submitInvoiceData.current.CustomerID = data.ID;
        addNewInvoice(invoiceType);
      }
    }
    setPopCustomer({ show: true, value: "", invoiceCustomers: true, setCustomerData: onSelectCust });
  }
  function printRequest(e) {
    history.push({
      pathname: "/PrintViewer/ProductRequest/" + e.ctrlKey,
      state: {
        dataUrl: `api/ProductRequestAPI/GetProductRequest?id=${ID}`,
        method: "get"
      }
    });
  }

  function selectText (e){
    e.target.select();
  };
  function handleInvoiceButtonClick(invoiceType)
  {
    const onSelect = (stg)=>{
      if(stg)
      {
        submitInvoiceData.current.StorageID = stg.StorageID;
        if(invoiceType === invoiceTypes.Borrow)
        {
          addNewInvoice(invoiceType);
        }
        else{
          showModalCustomerForInvoice(invoiceType)
        }
      }
    }
    setModalStorage({show:true, setStorageData: onSelect});
  }

  return (
    <div className="container-fluid mt-1">
      <br />
      <div className="card">
        <div className="card-header headerStyle" > درخواست قطعه </div>
        <div className='card-body bodyStyle' style={{ textAlign: "right" }}>
          <ModalProducts popData={popProduct} setProductPopup={setPopProduct} productGrouppingType={pgType} defaultSalePrice={pDefaultSalePrice} defaultSalePriceLabel={pDefaultSalePriceLabel} />
          {popStaff.show && <ModalSelectStaff popData={popStaff} setPopSelectStaff={setPopStaff} />}
          <ModalSelectCustomer nationalCodeIsRequired={false} popData={popCustomer} setCustomerPopup={setPopCustomer} />
          <ModalSearchStorage setStoragePoup={setModalStorage} popData={modalStorage} />
          {productRequest && productRequest.ID > 0 &&
            <Fragment>
              <ModalRequestComments requestID={productRequest.ID} />
              <ModalChangeRequestStatus />
            </Fragment>
          }
          <Accordion defaultActiveKey="1">
            <Card className="mt-2">
              <Accordion.Toggle as={Card.Header} eventKey="1" style={{ backgroundColor: "#279da3", color: "white" }}>
                <FontAwesomeIcon icon={faReceipt} size="lg" />&nbsp;
                مشخصات کلی درخواست
              </Accordion.Toggle>
              {productRequest && productRequest === "PENDING" &&
                <div style={{ textAlign: "center", padding: "5px" }}>
                  <Loader type="BallTriangle" height={30} width={30} color="#bb1370" />
                </div>
              }

              {productRequest && productRequest !== "PENDING" && Number(productRequest.ID) > -1 &&
                <Accordion.Collapse eventKey="1">
                  <Card.Body>
                    <FormGroup>
                      <div className="row">
                        {roleList && roleList.find(s => s === "Reception") && !roleList.find(s => s === "Staff") && !roleList.find(s => s === "Agent") &&
                          <div className='form-group  col-md-3'>
                            <label>تکنسین درخواست کننده</label><span style={{ color: "red" }}>*</span>
                            <input type='hidden' id="RF_StaffID" value={selectedStaff ? selectedStaff.ID : ""} readOnly />
                            <input placeholder='تکنسین را انتخاب کنید' type="text" className='form-control'
                              value={selectedStaff ? selectedStaff.LastName : productRequest.StaffName ? productRequest.StaffName : ""} readOnly onKeyDown={showModalStaff} />
                            &nbsp;
                            <Button className="btn-input-tiny" onClick={showModalStaff}><List size={23} /></Button>
                            {isStaffEmpty === true && <small className='errors'>تکنسین انتخاب نشده است</small>}
                          </div>
                        }
                        <Col md={3} className="form-group">
                          <label>تاریخ درخواست:</label>
                          <DatePicker isGregorian={false} timePicker={false} className="form-control" value={requestDate ? momentJalaali(requestDate) : null}
                            onChange={value => { setRequestDate(value.local("en").format("YYYY-MM-DD")) }} />
                        </Col>
                        <div className="form-group col-md-3">
                          <label> شماره درخواست </label>
                          <input className="form-control" name="RequestNo" type="text" readOnly value={productRequest.RequestNo} />
                        </div>
                        {Number(productRequest.ServiceID) > 0 &&
                          <Fragment>
                            <div className="form-group col-md-3">
                              <label> نوع سرویس </label>
                              <input className="form-control" name="ServiceTypeStr" type="text" readOnly value={productRequest.ServiceType === 'install' ? 'نصب' : 'تعمیر'} />
                            </div>
                            <div className="form-group col-md-3">
                              <label> شماره سرویس </label>
                              <input className="form-control" type="text" readOnly value={productRequest.ServiceNumber} />
                            </div>
                          </Fragment>}
                        <div className="form-group col-md-3">
                          <label > مشتری </label>
                          <input className="form-control" type="text" readOnly value={productRequest.CustomerName ?? ""} />
                        </div>
                        <div className="form-group col-md-3">
                          <label> محصول </label>
                          <input className="form-control" type="text" readOnly value={productRequest.ProductName ?? ""} />
                        </div>
                        <div className="form-group col-md-3">
                          <label> مدل محصول </label>
                          <input className="form-control" type="text" readOnly value={productRequest.ProductModel ?? ""} />
                        </div>
                        <div className="form-group col-md-3">
                          <label > سریال محصول </label>
                          <input className="form-control" type="text" readOnly value={productRequest.ProductSerial ?? ""} />
                        </div>
                        <div className="form-group col-md-3">
                          <label> آدرس </label>
                          <input className="form-control" type="text" readOnly value={productRequest.RequestAddress ?? ""} />
                        </div>
                        <div className="form-group col-md-3">
                          <label> نحوه ارسال </label>
                          <select className="form-control" defaultValue={productRequest.TypeAddress} onChange={e => productRequest.TypeAddress = e.target.value}>
                            <option value='1'>ارسال به دفتر خدمات پس از فروش</option>
                            <option value='2'>ارسال به آدرس مشتری</option>
                          </select>
                        </div>
                        <div className="form-group col-md-3">
                          <label >وضعیت درخواست</label>
                          <input type="text" className="form-control" value={productRequest.StatusStr ?? ""} readOnly style={{ color: "red" }} />
                        </div>
                        {(Number(productRequest.ID) > 0) &&
                          <div className="form-group col-md-3">
                            <label >آخرین ملاحظه</label>
                            <input type="text" className="form-control" value={productRequest.LastComment ?? " "} readOnly style={{ color: "red" }} />
                          </div>
                        }
                      </div>
                    </FormGroup>
                  </Card.Body>
                </Accordion.Collapse>
              }
              {
                Number(productRequest.ID) === -1 &&
                <Accordion.Collapse eventKey="1">
                  <Card.Body>

                    <FormGroup>
                      <div className="row">
                        <Col md={3} className="form-group">
                          <label>تاریخ درخواست:</label>
                          <DatePicker isGregorian={false} timePicker={false} className="form-control" value={requestDate ? momentJalaali(requestDate) : null}
                            onChange={value => setRequestDate(value.local("en").format("YYYY-MM-DD"))} />
                        </Col>
                        {roleList && roleList.find(s => s === "Reception") && !roleList.find(s => s === "Staff") && !roleList.find(s => s === "Agent") &&
                          <div className='form-group  col-md-3'>
                            <label>تکنسین درخواست کننده</label><span style={{ color: "red" }}>*</span>
                            <input type='hidden' id="RF_StaffID" value={selectedStaff ? selectedStaff.ID : ""} readOnly />
                            <input placeholder='تکنسین را انتخاب کنید' type="text" className='form-control'
                              value={selectedStaff ? selectedStaff.LastName : ""} readOnly onKeyDown={showModalStaff} />
                            <Button className="btn-input-tiny" onClick={showModalStaff}><List size={21} /></Button>
                            {isStaffEmpty === true && <small className='errors'>تکنسین انتخاب نشده است</small>}
                          </div>
                        }
                        <div className="form-group col-md-3">
                          <label>نام مشتری</label>
                          <input type="hidden" name="CustomerID" value={selectedCustomer.ID ? selectedCustomer.ID : ""} readOnly />
                          <input placeholder='مشتری را انتخاب کنید' type="text" className="form-control" name="CustomerName"
                            value={selectedCustomer && selectedCustomer.Name ? selectedCustomer.Name : ""} readOnly onKeyDown={showModalCustomer} />
                          <Button className="btn-input-tiny" onClick={showModalCustomer}><List size={21} /></Button>
                        </div>
                        <div className="form-group col-md-3">
                          <label>{pgType === 1 ? ('نام و مدل محصول') : ('مارک، نوع، مدل محصول')} </label><span style={{ color: "red" }}>*</span>
                          <input type='hidden' name="ProductID" value={selectedMainProduct && selectedMainProduct.ProductID ? selectedMainProduct.ProductID : ""} />
                          <input type="text" placeholder='محصول را انتخاب کنید' className="form-control" name="ProductName" onKeyDown={showModalMainProduct}
                            value={selectedMainProduct && selectedMainProduct.ProductName ? (selectedMainProduct.HolderName ? selectedMainProduct.HolderName + "-" : "") + selectedMainProduct.ProductName + '-' + selectedMainProduct.ProductModel : ""} readOnly />
                          <Button className="btn-input-tiny" onClick={showModalMainProduct}><List size={21} /></Button>
                          {checkRequired && !selectedMainProduct.ProductID && <small className="errors"> انتخاب محصول الزامی است </small>}
                        </div>
                        <div className="form-group col-md-3">
                          <label> سریال محصول </label>
                          <input className="form-control" type="text" onChange={e => requestData.current.ProductSerial = e.target.value} style={{ fontFamily: "Dark-Sans", fontSize: "11.5px" }} />
                        </div>
                        <div className="form-group col-md-3">
                          <label > نحوه ارسال </label><span style={{ color: "red", fontSize: "12px" }}>*</span>
                          <select className="form-control" onChange={e => requestData.current.TypeAddress = e.target.value}>
                            <option value=''>انتخاب کنید</option>
                            <option value='1'>ارسال به دفتر خدمات پس از فروش</option>
                            <option value='2'>ارسال به آدرس مشتری</option>
                          </select>
                          {checkRequired && !requestData.current.TypeAddress && <small className="errors">انتخاب نحوه ارسال الزامی است</small>}
                        </div>
                        <div className="form-group col-md-6">
                          <label > آدرس </label><span style={{ color: "red", fontSize: "12px" }}>*</span>
                          <input className="form-control" type="text" onChange={e => requestData.current.RequestAddress = e.target.value} />
                          {checkRequired && !requestData.current.RequestAddress && <small className="errors">آدرس وارد نشده است</small>}
                        </div>
                      </div>
                    </FormGroup>
                  </Card.Body>
                </Accordion.Collapse>
              }
            </Card>
            {((productRequest && productRequest !== "PENDING")) &&
              <Card className="mt-1">
                <Accordion.Toggle as={Card.Header} eventKey="2" style={{ backgroundColor: "rgb(109 132 214)", color: "white" }}>
                  <FontAwesomeIcon icon={faListAlt} size="lg" />&nbsp;
                  ریز درخواست
                </Accordion.Toggle>
                <Accordion.Collapse eventKey="2">
                  <Card.Body>
                    {(Number(productRequest.ID) === -1 || (Number(productRequest.StatusCode) === productRequestStatuses.FeedBack || Number(productRequest.StatusCode) === productRequestStatuses.Draft)) &&
                      <Fragment>
                        <form readOnly onSubmit={handleSubmit(AddSegment)} ref={frmRequestDetails}>
                          <div className="row">
                            <div className="form-group">
                              <input type="checkbox" ref={register({})} name="IsGaurantee" /><span style={{ color: "#d40f6a" }}>  قطعه گارانتی است&nbsp;&nbsp;</span>
                            </div>
                          </div>
                          <div className="row">
                            <div className="form-group col-md-3">
                              <label>نام قطعه</label>
                              <input className="form-control" type="text" name="ProductName" value={selectedProduct && selectedProduct.ProductName ? selectedProduct.ProductName : ""}
                                readOnly onKeyDown={showModalProduct} /><span>&nbsp;</span>
                              <Button className="btn-input-tiny" onClick={showModalProduct}><List size={20} /></Button>
                              {errors && errors.ProductName && <small className="error">انتخاب کالا الزامی است</small>}
                            </div>
                            <div className="form-group col-md-3">
                              <label>مدل قطعه</label>
                              <input className="form-control" type="text" value={selectedProduct && selectedProduct.ProductModel ? selectedProduct.ProductModel : ""} readOnly /><span>&nbsp;</span>
                            </div>
                            <div className="form-group col-md-3">
                              <label>تعداد</label>
                              <input id="requestProductCount" className="form-control" type="number" ref={register({ required: true })} name="Count" defaultValue={1} min={1} onFocus={selectText} />
                              {errors && errors.Count && <small className="errors">تعداد کالا الزامی است</small>}
                            </div>
                            <div className="form-group col-md-3">
                              <label>توضیحات</label>
                              <input className="form-control" type="text" ref={register({})} name="Description" />
                            </div>
                          </div>
                          <Button type="submit" className="group-Btn"><PlusLg /> افزودن به لیست</Button>
                        </form>
                      </Fragment>
                    }
                    <Table className="mt-2">
                      <thead>
                        <tr>
                          <th style={{ display: "none" }}></th>
                          {window.innerWidth >= 414 && <th></th>}
                          <th>نام قطعه</th>
                          <th>مدل قطعه</th>
                          <th>تعداد</th>
                          <th>توضیحات</th>
                          {window.innerWidth >= 414 && <th></th>}
                        </tr>
                      </thead>
                      <tbody>
                        {!productRequest.IsNew && requestDetails && Array.isArray(requestDetails) && requestDetails.map((item, i) => {
                          return <tr className="resultTableRow" key={i} onClick={() => {
                            if (window.innerWidth < 414) {
                              dispatch(setDialog({
                                status: 'show',
                                arrayBtn: ['yes', 'no'],
                                dialogTitle: 'حذف ردیف',
                                dialogText: 'آیا از حذف مطمئن هستید؟',
                                okOperation: deleteRow(item.Index, item.ID)
                              }))
                            }
                          }}>
                            <td style={{ display: "none" }}></td>
                            {window.innerWidth >= 414 && <td style={{ width: "5px" }}>{item.Index}</td>}
                            <td className="columnForPrint">{item.ProductName}</td>
                            <td className="columnForPrint">{item.ProductModel}</td>
                            <td className="columnForPrint">{item.Counts}</td>
                            <td className="columnForPrint">{item.Description}</td>
                            {window.innerWidth >= 414 &&
                              <td><Trash size={18} style={{ color: "red" }}
                                onClick={() => {
                                  dispatch(setDialog({
                                    status: 'show',
                                    arrayBtn: ['yes', 'no'],
                                    dialogTitle: 'حذف ردیف',
                                    dialogText: 'آیا از حذف مطمئن هستید؟',
                                    okOperation: deleteRow(item.Index, item.ID)
                                  }))
                                }} />
                              </td>
                            }
                          </tr>
                        })}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Accordion.Collapse>
              </Card>
            }

          </Accordion>
          {(!productRequest.ID || Number(productRequest.ID) === 0 || Number(productRequest.ID) === -1) &&
            <div className="mt-4">
              <button type="button" className="btn btn-success btn-block group-Btn" onClick={onSubmit}><Save size={15} />  ثبت درخواست   </button>
            </div>
          }
          {(productRequest && Number(productRequest.ID) > 0) &&
            <div className="mt-4">
              {Number(productRequest.StatusCode) === productRequestStatuses.Draft &&
                <Button className="group-Btn btn-info" onClick={sendRequest}><LayerForward size={17} style={{ marginTop: "-4px", marginLeft: "1px" }} />&nbsp;{loading && 'صبر کنید'}{!loading && 'تایید نهایی'}</Button>}
              <button type="button" className="btn btn-secondary btn-block group-Btn" onClick={showMessages}><ExclamationSquare size={16} /> ملاحظات درخواست   </button>
              {!isMobile &&
                <Fragment>
                  <Button className="group-Btn" onClick={showCommand}><Command size={17} />&nbsp;دستور کار</Button>
                  {Number(productRequest.StatusCode) !== productRequestStatuses.Closed && (Number(productRequest.StatusCode) !== productRequestStatuses.Draft) &&
                    <Button className="group-Btn btn-violet" onClick={showModalStatus}><UiChecksGrid size={17} />&nbsp;وضعیت درخواست</Button>}
                  {Number(productRequest.StatusCode) === productRequestStatuses.Confirmed &&
                      <Button variant="info" className="group-Btn" onClick={()=>handleInvoiceButtonClick(invoiceTypes.Borrow)} disabled={pendingInvoice}><FileEarmarkSpreadsheet size={19} />&nbsp;حواله به نماینده/تکنسین</Button>
                  }
                  {(Number(productRequest.StatusCode) === productRequestStatuses.Confirmed || Number(productRequest.StatusCode) === productRequestStatuses.Closed) &&
                  <>
                    <Button className="group-Btn" variant="info" onClick={()=>handleInvoiceButtonClick(invoiceTypes.PrePurchase)} disabled={pendingInvoice}><FileEarmarkPlus size={19}/>&nbsp; ثبت پیش فاکتور خرید</Button>
                    <Button className="group-Btn" onClick={()=>handleInvoiceButtonClick(invoiceTypes.Purchase)} disabled={pendingInvoice}><FileEarmarkPlus size={19}/>&nbsp; ثبت فاکتور خرید</Button>
                  </>
                  }
                </Fragment>
              }
              <Button className="group-Btn" variant="secondary" onClick={printRequest}><Printer size={18} />&nbsp;چاپ درخواست</Button>
            </div>
          }
        </div>
      </div>
    </div >
  )

}
export default PartRequest;

<script>

</script>